/* Your Legacy — cart drawer (v9.8, 2026-10-18).

   Rendered from `window.CBC_CART`: opening costs no request.

   Each product group starts with the PRODUCT NAME (e.g. "Your Legacy™ – Family Story Journal"),
   then the "N copies · N recipients" line when several variants are in the cart, then one row per
   variant (Dad, Mom…).

   Quantities: clicks update the display first (optimistic), then ALL pending changes go out in
   ONE `/cart/update.js` request after 260 ms of inactivity. Stale line keys are remapped by
   variant and retried once.

   Gifts: a line is a gift if it carries the `_offert` property or its original price is 0.
   From GIFT_MIN journals, every gift in CFG.giftSpec for the journal's language is kept in the
   cart at the right quantity: the family game once, the golden pen once PER journal (perBook).
   Below the threshold every gift is removed. Duplicate gift lines are merged.

   Checkout: this script does NOT touch the Checkout button. It is a standard Shopify checkout
   button (<form action="/cart" method="post"><button type="submit" name="checkout" id="checkout">)
   so snippets/cc-checkout-redirect can send the cart to the Checkout Champ funnel. The button is
   only disabled while a quantity change is still being saved, so the checkout always receives the
   final cart. No fetch interception and no redirect in this script.

   Shipping protection: CFG.protect = { variantId, productId }. The row in the drawer footer is a
   toggle, ON by default: as soon as the cart holds a paid product, one protection line is added
   automatically; switching it off removes it and remembers the choice for the session
   (sessionStorage "yl_protect_off"), so it is not re-added behind the shopper's back. The line is
   never shown in the product list and never counts as a journal.

   Money: always two decimals (no rounding to whole units), in the cart's currency.

   Market price layer (v9.5): Shopify can only present USD (no Shopify Payments), but the checkout
   charges some markets in their own currency (Mexico in MXN). On such a market
   `window.CBC_MARKET` (snippets/cbc-market) carries the per-variant prices the checkout charges, and
   the drawer recomputes every line and total from them, mirroring the automatic discounts
   (CFG.discountSets, same rules as Shopify's "minimum quantity" product discounts, which count
   eligible products only): −20/−30/−40 % on the family journals from 2/3/4 journals, −20/−30 % on
   the couple set (Couple Story Journal + About You + Me card game) from 2/3 items — exact
   percentages, no rounding — gifts free, protection at its market price. If ONE paid line has no
   market price the whole drawer falls back to the Shopify (USD) cart, so a peso figure the checkout
   would not charge is never shown.

   Same figures as the product page (v9.8): on the default market the drawer no longer shows
   Shopify's own cart arithmetic (Shopify truncates the per-unit discount to the cent, so a Trio
   reads $63.00 while the buy box advertises $62.99). Lines and totals are recomputed from the
   Shopify unit prices with the buy box's rules, per discount set: "nice" rounding for the journal
   tiers (the set total is rounded UP to .99 — .90 in EUR — exactly like the buy box, the odd cent
   goes on the first line), exact cent rounding per line for the couple set (what the offers page
   shows). Gifts free, shipping protection at its price, other products untouched. Skipped when
   the cart carries a discount that is not one of the automatic ones (a code), so a code is never
   hidden.

   Analytics (v9.7): the ONLY add this script reports is the shopper's own "Add a journal" tap
   (window.CBCTrack.addToCart, one event). Gifts, shipping protection and variant swaps are cart
   repairs, never AddToCart events — see snippets/cbc-track.liquid.

   Language: every visible string comes from CBC_CART_CONFIG.i18n (English / Spanish). */
(function () {
  "use strict";

  var CFG = window.CBC_CART_CONFIG || {};
  var I = CFG.i18n || {};
  function T(k, vars) {
    var s = I[k] != null ? I[k] : k;
    if (vars) Object.keys(vars).forEach(function (v) { s = s.split("{" + v + "}").join(vars[v]); });
    return s;
  }
  function log() { try { console.log.apply(console, ["[YL]"].concat([].slice.call(arguments))); } catch (x) {} }
  function warn() { try { console.warn.apply(console, ["[YL]"].concat([].slice.call(arguments))); } catch (x) {} }
  var GIFT_IDS = CFG.giftIds || [];
  var GIFT_SPEC = CFG.giftSpec || {};
  var BOOK_PIDS = CFG.bookProductIds || [];
  var GAME_PIDS = CFG.gameProductIds || BOOK_PIDS;
  var GIFT_MIN = CFG.giftMin || 2;
  var SHIP_QTY = CFG.freeShipQty || 2;
  var UNIT = CFG.unitCents || 0;
  var TIERS = CFG.tiers || {};
  var FAM_PCT = CFG.famillePct || 40;
  var TIER_PCT = CFG.tierPct || {};
  var DEBOUNCE = CFG.debounceMs == null ? 260 : CFG.debounceMs;
  var PROTECT = CFG.protect && CFG.protect.variantId ? CFG.protect : null;
  var PROTECT_KEY = "yl_protect_off", protectHealed = false;
  /* Automatic product discounts mirrored in market mode: [{ productIds, pct: { "2": 20, ... } }].
     Default: the journal tiers on the products that unlock the gifts (the same products the
     Duo/Trio/Family discounts are set on). */
  var SETS = Array.isArray(CFG.discountSets) && CFG.discountSets.length ? CFG.discountSets : [{ productIds: GAME_PIDS, pct: { "2": TIER_PCT[2], "3": TIER_PCT[3], "4": FAM_PCT } }];
  var CART_PATH = /^(\/[a-z]{2}(?:-[a-z]{2})?)?\/cart\/?$/i;
  var cart = window.CBC_CART || { items: [], item_count: 0 };
  var lastFocus = null, giftBusy = false;
  var pending = {}, pendingVid = {}, flushT = null, inFlight = false;
  var variantCache = {}, moreOpen = {};
  var mq = null; /* current market quote (see marketQuote), set at the start of every render */

  var GIFT_ICON = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor"'
    + ' stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">'
    + '<path d="M20 12v9H4v-9"/><rect x="2" y="7" width="20" height="5" rx="1"/><path d="M12 21V7"/>'
    + '<path d="M12 7H7.5a2.5 2.5 0 0 1 0-5C11 2 12 7 12 7z"/>'
    + '<path d="M12 7h4.5a2.5 2.5 0 0 0 0-5C13 2 12 7 12 7z"/></svg>';
  var PLUS_ICON = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor"'
    + ' stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M12 5v14M5 12h14"/></svg>';

  var root = document.querySelector("[data-cbcd]");
  var scrim = document.querySelector("[data-cbcd-scrim]");
  if (!root || !scrim) { warn("cart drawer markup missing — cbc-cart-drawer snippet not rendered"); return; }
  log("cart drawer v9.8 ready — checkout handled by Checkout Champ (cc-checkout-redirect)" + (window.CBC_MARKET ? ", market " + window.CBC_MARKET.currency : ""));

  var rawFetch = function () { return window.fetch.apply(window, arguments); };
  var $ = function (s, r) { return (r || root).querySelector(s); };
  var itemsEl = $("[data-cbcd-items]");
  var countEl = $("[data-cbcd-count]");
  var shipEl = $("[data-cbcd-ship]");
  var upsellEl = $("[data-cbcd-upsell]");

  var nfCache = {}, mkNf = null;
  function money(c) {
    if (mq && mq.mk) {
      if (mkNf === null) {
        try { mkNf = new Intl.NumberFormat(mq.mk.locale || CFG.locale || "en", { minimumFractionDigits: 2, maximumFractionDigits: 2 }); } catch (e) { mkNf = false; }
      }
      return (mq.mk.prefix || "") + (mkNf ? mkNf.format(c / 100) : (c / 100).toFixed(2)) + (mq.mk.prefix ? "" : " " + mq.mk.currency);
    }
    var cur = cart.currency || "USD";
    if (!(cur in nfCache)) {
      try {
        nfCache[cur] = new Intl.NumberFormat(CFG.locale || document.documentElement.lang || "en", { style: "currency", currency: cur, minimumFractionDigits: 2, maximumFractionDigits: 2 });
      } catch (e) { nfCache[cur] = null; }
    }
    var nf = nfCache[cur];
    return nf ? nf.format(c / 100) : (c / 100).toFixed(2) + " " + cur;
  }
  function esc(s) {
    return String(s == null ? "" : s).replace(/[&<>"']/g, function (m) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[m];
    });
  }
  function isGift(it) {
    if (it.properties && (it.properties._offert || it.properties._gift)) return true;
    return it.original_price === 0;
  }
  function isProtect(it) { return !!PROTECT && it.variant_id === PROTECT.variantId; }
  function protectLines() { return (cart.items || []).filter(isProtect); }
  function paidLines() { return (cart.items || []).filter(function (it) { return !isGift(it) && !isProtect(it); }); }
  function protectOff() { try { return window.sessionStorage.getItem(PROTECT_KEY) === "1"; } catch (e) { return false; } }
  function setProtectOff(v) { try { if (v) window.sessionStorage.setItem(PROTECT_KEY, "1"); else window.sessionStorage.removeItem(PROTECT_KEY); } catch (e) {} }
  function isBook(it) {
    if (isGift(it) || isProtect(it)) return false;
    return BOOK_PIDS.length ? BOOK_PIDS.indexOf(it.product_id) !== -1 : true;
  }
  function giftLines() { return (cart.items || []).filter(function (it) { return GIFT_IDS.indexOf(it.variant_id) !== -1 && isGift(it); }); }
  function hasGift() { return giftLines().length > 0; }
  function img(src, w) { return src ? src.replace(/(\.(?:jpg|jpeg|png|webp|gif))(\?|$)/i, "_" + w + "x$1$2") : ""; }
  function count(pred) {
    var n = 0;
    (cart.items || []).forEach(function (it) { if (pred(it)) n += it.quantity; });
    return n;
  }
  function bookCount() { return count(isBook); }
  function gameBookCount() { return count(function (it) { return !isGift(it) && GAME_PIDS.indexOf(it.product_id) !== -1; }); }
  function expectedGifts() {
    var n = gameBookCount();
    var first = (cart.items || []).filter(function (it) { return !isGift(it) && GAME_PIDS.indexOf(it.product_id) !== -1; })[0];
    var pid = first ? String(first.product_id) : "";
    var spec = GIFT_SPEC[pid] || [];
    return spec.map(function (g) { return { id: g.id, qty: g.perBook ? n : 1 }; });
  }
  function tierTotal(q) {
    if (q <= 0) return 0;
    if (q >= 4) return Math.round(q * UNIT * (1 - FAM_PCT / 100));
    if (TIERS[q] != null) return TIERS[q];
    return q * UNIT;
  }
  /* Bundle discount shown on the upsell button: the ROUND tier percentages (20/30/40), the same
     numbers the buy box advertises — never the odd figure derived from .99-rounded totals. */
  function tierPct(q) {
    if (q >= 4) return FAM_PCT;
    if (TIER_PCT[q] != null) return +TIER_PCT[q];
    if (UNIT > 0 && q > 1) return Math.round((1 - tierTotal(q) / (q * UNIT)) * 100);
    return 0;
  }
  function nextOfferLabel() {
    var next = gameBookCount() + 1, parts = [];
    var pct = tierPct(next);
    if (pct > 0) parts.push("−" + pct + "%");
    if (next >= GIFT_MIN && !hasGift() && GIFT_IDS.length) parts.push(T("theFreeGame"));
    return parts.length ? T("addBookGet", { x: parts.join(" + ") }) : T("addBook");
  }

  /* Buy-box rounding of a set total (default market only): the exact percentage, then rounded UP
     to the next .99 (.90 in EUR) — sections/cbc-product-buybox.liquid, journalsTotal(). */
  function niceTotal(fullCents, pct) {
    if (pct <= 0) return fullCents;
    var net = fullCents - Math.round(fullCents * pct / 100);
    var end = (cart.currency || "USD") === "EUR" ? 90 : 99;
    var n = Math.floor(net / 100) * 100 + end;
    return n < net ? n + 100 : n;
  }
  function setRounding(pid) {
    for (var i = 0; i < SETS.length; i++) if ((SETS[i].productIds || []).indexOf(pid) !== -1) return SETS[i].rounding || "exact";
    return "exact";
  }
  /* Default market: the Shopify cart re-priced with the buy box's rules (see the header). Returns
     null when the cart carries a discount that is not automatic (a code), so nothing is hidden. */
  function storeQuote() {
    var items = cart.items || [];
    var apps = cart.cart_level_discount_applications || [];
    for (var a = 0; a < apps.length; a++) if (apps[a].type && apps[a].type !== "automatic") return null;
    var pctOf = setPercents(items);
    var orig = 0, fin = 0, lines = {}, sets = {};
    items.forEach(function (it) {
      var u = isGift(it) ? 0 : (it.original_price || 0);
      var o = u * it.quantity;
      var p = isGift(it) || isProtect(it) ? 0 : (pctOf[it.product_id] || 0);
      var f = p > 0 ? Math.round(o * (100 - p) / 100) : o;
      orig += o;
      lines[it.key] = { unit: u, orig: o, final: f, pct: p };
      if (p > 0 && setRounding(it.product_id) === "nice") {
        var key = String(p);
        if (!sets[key]) sets[key] = { full: 0, sum: 0, first: null };
        sets[key].full += o; sets[key].sum += f;
        if (!sets[key].first) sets[key].first = it.key;
      }
    });
    Object.keys(sets).forEach(function (k) {
      var st = sets[k], want = niceTotal(st.full, +k), diff = want - st.sum;
      if (diff && st.first && lines[st.first]) lines[st.first].final += diff;
    });
    Object.keys(lines).forEach(function (k) { fin += lines[k].final; });
    return { mk: null, pct: pctOf[GAME_PIDS[0]] || 0, original_total_price: orig, total_price: fin, lines: lines };
  }
  /* Market price layer — see the header comment. On the default market, the store quote above. */
  function marketQuote() {
    var MK = window.CBC_MARKET;
    if (!MK || !MK.currency || !MK.prices || MK.currency === (cart.currency || "USD")) return storeQuote();
    var items = cart.items || [], i;
    for (i = 0; i < items.length; i++) {
      if (!isGift(items[i]) && MK.prices[items[i].variant_id] == null) {
        warn("market: no " + MK.currency + " price for variant " + items[i].variant_id + " — showing the USD cart");
        return null;
      }
    }
    var orig = 0, fin = 0, lines = {};
    var pctOf = setPercents(items);
    items.forEach(function (it) {
      var u = isGift(it) ? 0 : MK.prices[it.variant_id];
      var o = u * it.quantity;
      var p = isGift(it) || isProtect(it) ? 0 : (pctOf[it.product_id] || 0);
      var f = p > 0 ? Math.round(o * (100 - p)) / 100 : o;
      orig += o; fin += f;
      lines[it.key] = { unit: u, orig: o, final: f, pct: p };
    });
    return { mk: MK, pct: pctOf[GAME_PIDS[0]] || 0, original_total_price: orig, total_price: fin, lines: lines };
  }
  /* For every product id in a discount set, the percentage its lines get: the highest threshold
     reached by the quantity of eligible (paid, non-protection) items of that set. */
  function setPercents(items) {
    var out = {};
    SETS.forEach(function (set) {
      var ids = set.productIds || [], q = 0;
      items.forEach(function (it) { if (!isGift(it) && !isProtect(it) && ids.indexOf(it.product_id) !== -1) q += it.quantity; });
      var best = 0;
      Object.keys(set.pct || {}).forEach(function (k) { var th = +k, v = +set.pct[k]; if (q >= th && v > best) best = v; });
      ids.forEach(function (id) { if (best > (out[id] || 0)) out[id] = best; });
    });
    return out;
  }
  function lineFinal(it) { return mq && mq.lines[it.key] ? mq.lines[it.key].final : it.final_line_price; }
  function lineOrig(it) { return mq && mq.lines[it.key] ? mq.lines[it.key].orig : it.original_line_price; }

  function applyPending(c) {
    var keys = Object.keys(pending);
    if (!keys.length) return c;
    (c.items || []).forEach(function (it) { if (it.key in pending) it.quantity = pending[it.key]; });
    c.items = (c.items || []).filter(function (it) { return it.quantity > 0; });
    c.item_count = (c.items || []).reduce(function (s, it) { return s + it.quantity; }, 0);
    return c;
  }
  function setCart(c) { cart = applyPending(c || { items: [], item_count: 0 }); }

  function render() {
    mq = marketQuote();
    var paid = [], gifts = [], protect = [];
    (cart.items || []).forEach(function (it) { (isProtect(it) ? protect : isGift(it) ? gifts : paid).push(it); });

    var groups = [], gix = {};
    paid.forEach(function (it) {
      if (gix[it.product_id] == null) { gix[it.product_id] = groups.length; groups.push({ handle: it.handle, title: it.product_title, vars: [], vix: {} }); }
      var g = groups[gix[it.product_id]];
      if (g.vix[it.variant_id] == null) {
        g.vix[it.variant_id] = g.vars.length;
        g.vars.push({
          vid: it.variant_id,
          name: it.variant_title && it.variant_title !== "Default Title" ? it.variant_title : it.product_title,
          image: it.image, qty: 0, final: 0, orig: 0, keys: []
        });
      }
      var v = g.vars[g.vix[it.variant_id]];
      v.qty += it.quantity;
      v.final += lineFinal(it);
      v.orig += lineOrig(it);
      v.keys.push(it.key);
    });

    var html = "";
    if (!paid.length && !gifts.length) html = '<div class="cbcd-empty">' + esc(T("empty")) + "</div>";
    renderProtect(paid.length > 0, protect);

    groups.forEach(function (g) {
      var n = g.vars.reduce(function (s, v) { return s + v.qty; }, 0);
      var hasVariants = g.vars.length > 1 || (g.vars[0] && g.vars[0].name !== g.title);
      html += '<article class="cbcd-prod">';
      if (hasVariants) html += '<h3 class="cbcd-ptitle">' + esc(g.title) + "</h3>";
      g.vars.forEach(function (v) {
        var save = v.orig - v.final, keys = esc(v.keys.join("|"));
        html +=
          '<div class="cbcd-v" data-vid="' + v.vid + '">' +
            (v.image ? '<img src="' + esc(img(v.image, 160)) + '" alt="" loading="lazy">' : "<span></span>") +
            '<div class="cbcd-mid"><div class="cbcd-name">' + esc(v.name) + "</div>" +
              '<div class="cbcd-qty"><span class="cbcd-step">' +
                '<button type="button" data-act="dec" data-keys="' + keys + '" aria-label="' + esc(T("removeOne")) + '">−</button>' +
                "<span>" + v.qty + "</span>" +
                '<button type="button" data-act="inc" data-keys="' + keys + '" aria-label="' + esc(T("addOne")) + '">+</button></span>' +
                '<button type="button" class="cbcd-trash" data-act="del" data-keys="' + keys + '" aria-label="' + esc(T("remove")) + '">' +
                  '<svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M4 7h16M10 11v6M14 11v6M5 7l1 13h12l1-13M9 7V4h6v3"/></svg>' +
                "</button></div></div>" +
            '<div class="cbcd-price">' +
              (save > 0 ? '<span class="cbcd-cut">−' + money(save) + "</span>" : "") +
              "<b>" + money(v.final) + "</b>" + (save > 0 ? "<s>" + money(v.orig) + "</s>" : "") +
            "</div></div>";
      });
      var vars = g.handle ? variantCache[g.handle] : null;
      if (vars && vars.length > 1) {
        var open = !!moreOpen[g.handle];
        var opts = '<option value="" selected disabled>' + esc(T("pick")) + "</option>" +
          vars.map(function (v) { return '<option value="' + v.id + '">' + esc(v.title) + "</option>"; }).join("");
        html += '<div class="cbcd-more"' + (open ? " data-open" : "") + ">" +
          '<select class="cbcd-mini cbcd-morevar" data-morevar="' + esc(g.handle) + '" aria-label="' + esc(T("recipientToAdd")) + '"' + (open ? "" : " hidden") + ">" + opts + "</select>" +
          '<button type="button" data-act="more" data-handle="' + esc(g.handle) + '">' + (open ? "" : PLUS_ICON) + " " + esc(open ? T("add") : nextOfferLabel()) + "</button></div>";
      }
      html += "</article>";
    });

    gifts.forEach(function (it) {
      html += '<article class="cbcd-gift" data-vid="' + it.variant_id + '">' +
        (it.image ? '<img src="' + esc(img(it.image, 160)) + '" alt="" loading="lazy">' : "<span></span>") +
        '<div><div class="t">' + (it.quantity > 1 ? it.quantity + " × " : "") + esc(it.product_title) + "</div>" +
        '<div class="s">' + GIFT_ICON + " " + esc(T("free")) + "</div></div><b>" + money(lineFinal(it) || 0) + "</b></article>";
    });

    itemsEl.innerHTML = html;
    groups.forEach(function (g) { if (g.handle && variantCache[g.handle] === undefined) loadVariants(g.handle); });

    var books = bookCount();
    var done = books >= SHIP_QTY;
    var pct = Math.min(100, (books / SHIP_QTY) * 100);
    $("[data-cbcd-fill]").style.width = pct + "%";
    $("[data-cbcd-knob]").style.left = pct + "%";
    if (done) shipEl.setAttribute("data-done", ""); else shipEl.removeAttribute("data-done");
    var left = Math.max(1, SHIP_QTY - books);
    $("[data-cbcd-shiptxt]").innerHTML = done ? esc(T("shipDone"))
      : !(cart.items || []).length ? esc(T("shipFrom", { n: SHIP_QTY }))
      : left === 1 ? T("shipOne")
      : T("shipMany", { n: left });

    var totalPrice = mq ? mq.total_price : (cart.total_price || 0);
    var originalTotal = mq ? mq.original_total_price : (cart.original_total_price || 0);
    var save = originalTotal - totalPrice;
    var titles = (cart.cart_level_discount_applications || []).map(function (a) { return a.title; }).filter(Boolean);
    var shown = (cart.item_count || 0) - protect.reduce(function (s, it) { return s + it.quantity; }, 0);
    countEl.textContent = shown;
    syncBadges(shown);
    $("[data-cbcd-sub]").textContent = money(totalPrice);
    $("[data-cbcd-subcompare]").textContent = save > 0 ? money(originalTotal) : "";
    $("[data-cbcd-cutrow]").style.display = save > 0 ? "" : "none";
    $("[data-cbcd-cuttag]").textContent = titles.length ? titles[0] : books + (books > 1 ? T("books") : T("book"));
    $("[data-cbcd-cut]").textContent = "−" + money(save);
    $("[data-cbcd-total]").textContent = money(totalPrice);
    $("[data-cbcd-go]").disabled = !((cart.items || []).length > 0) || inFlight || Object.keys(pending).length > 0;
    if (upsellEl) upsellEl.hidden = !(cart.item_count > 0);
    syncUpsell();
  }

  /* Shipping-protection row (footer toggle). Shown only when the cart holds a paid product. */
  function renderProtect(show, lines) {
    var row = $("[data-cbcd-protect]"); if (!row) return;
    if (!PROTECT || !show) { row.hidden = true; return; }
    row.hidden = false;
    var on = lines.length > 0;
    var box = $("[data-cbcd-protect-toggle]"); if (box) box.checked = on;
    var price = $("[data-cbcd-protect-price]");
    if (price) {
      var off = PROTECT.priceCents || 0;
      if (mq && mq.mk && mq.mk.prices[PROTECT.variantId] != null) off = mq.mk.prices[PROTECT.variantId];
      price.textContent = money(on ? lineFinal(lines[0]) : off);
    }
    if (on) row.setAttribute("data-on", ""); else row.removeAttribute("data-on");
  }
  function enforceProtect() {
    if (!PROTECT || inFlight || Object.keys(pending).length) return false;
    var lines = protectLines(), hasPaid = paidLines().length > 0;
    if (!hasPaid || protectOff()) {
      lines.forEach(function (it) { setQty(it.key, 0); });
      return lines.length > 0;
    }
    if (!lines.length) {
      addItems([{ id: PROTECT.variantId, quantity: 1, properties: { _protect: "1" } }]);
      return true;
    }
    /* Stale price (line added before the product's price changed): drop the line, it is re-added
       at the current price on the next pass. */
    if (PROTECT.priceCents && !protectHealed && lines[0].original_price !== PROTECT.priceCents) {
      protectHealed = true;
      lines.forEach(function (it) { setQty(it.key, 0); });
      return true;
    }
    if (lines[0].quantity !== 1) setQty(lines[0].key, 1);
    lines.slice(1).forEach(function (it) { setQty(it.key, 0); });
    return false;
  }

  /* Header cart badge(s): rendered by Liquid at page load, kept in sync here after every cart
     change (otherwise an emptied cart still showed the old count in the header). */
  function syncBadges(n) {
    var nodes = document.querySelectorAll("[data-cbcd-badge], .cbc-hd__cart b, [data-cart-count]");
    for (var i = 0; i < nodes.length; i++) {
      var b = nodes[i];
      if (b === countEl) continue;
      b.textContent = n;
      if (n > 0) { b.hidden = false; b.style.display = ""; } else { b.hidden = true; b.style.display = "none"; }
    }
  }

  function loadVariants(handle) {
    variantCache[handle] = null;
    rawFetch("/products/" + encodeURIComponent(handle) + ".js").then(function (r) { return r.json(); })
      .then(function (p) { variantCache[handle] = (p.variants || []).filter(function (v) { return v.available; }); render(); })
      .catch(function () { variantCache[handle] = []; });
  }

  function post(url, body) {
    return rawFetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify(body)
    }).then(function (r) {
      return r.json().catch(function () { return {}; }).then(function (j) {
        if (!r.ok) {
          var err = new Error(j && (j.description || j.message) ? j.description || j.message : "HTTP " + r.status);
          err.status = r.status; throw err;
        }
        return j;
      });
    });
  }
  function getCart() { return rawFetch("/cart.js", { headers: { Accept: "application/json" } }).then(function (r) { return r.json(); }); }

  function lineByKey(key) { return (cart.items || []).filter(function (it) { return it.key === key; })[0] || null; }

  function setQty(key, qty) {
    qty = Math.max(0, qty);
    var line = lineByKey(key);
    if (line) pendingVid[key] = line.variant_id;
    pending[key] = qty;
    setCart(cart);
    render();
    window.clearTimeout(flushT);
    flushT = window.setTimeout(flush, DEBOUNCE);
  }

  function remap(batch, fresh) {
    var out = {};
    Object.keys(batch).forEach(function (k) {
      if ((fresh.items || []).some(function (it) { return it.key === k; })) { out[k] = batch[k]; return; }
      var vid = pendingVid[k];
      var match = (fresh.items || []).filter(function (it) { return it.variant_id === vid && !(it.key in out); })[0];
      if (match) out[match.key] = batch[k];
    });
    return out;
  }

  function flush() {
    if (inFlight) { window.clearTimeout(flushT); flushT = window.setTimeout(flush, 80); return; }
    var batch = pending;
    if (!Object.keys(batch).length) return;
    pending = {};
    inFlight = true; root.setAttribute("data-busy", "");
    post("/cart/update.js", { updates: batch })
      .catch(function (e) {
        if (e.status && e.status >= 500) throw e;
        return getCart().then(function (fresh) {
          var retry = remap(batch, fresh);
          return Object.keys(retry).length ? post("/cart/update.js", { updates: retry }) : fresh;
        });
      })
      .then(function (c) { return c && c.items ? c : getCart(); })
      .catch(function () { return getCart(); })
      .then(function (c) {
        Object.keys(batch).forEach(function (k) { if (!(k in pending)) delete pendingVid[k]; });
        inFlight = false; root.removeAttribute("data-busy");
        setCart(c);
        render();
        if (Object.keys(pending).length) { window.clearTimeout(flushT); flushT = window.setTimeout(flush, DEBOUNCE); return; }
        enforceGift();
      }, function () { inFlight = false; root.removeAttribute("data-busy"); render(); });
  }

  function addItems(items) {
    if (!items.length) return Promise.resolve();
    root.setAttribute("data-busy", "");
    return post("/cart/add.js", { items: items })
      .then(getCart).then(setCart)
      .catch(function (e) { showError(e.message); })
      .then(function () { root.removeAttribute("data-busy"); render(); enforceGift(); });
  }
  function addVariant(id, qty, props) {
    if (!id) return Promise.resolve();
    var item = { id: id, quantity: qty || 1 };
    if (props) item.properties = props;
    return addItems([item]);
  }
  /* A journal the SHOPPER adds from the drawer ("Add a journal and get −30%", "Add" a recipient):
     ONE AddToCart event (see snippets/cbc-track). The drawer's own cart repairs — gifts, shipping
     protection, variant swap — go through addItems/setQty directly and are never tracked. */
  function shopperAdd(vid, source) {
    if (!vid) return Promise.resolve();
    var MK = window.CBC_MARKET, mkPrice = MK && MK.prices ? MK.prices[vid] : null;
    var unit = mkPrice != null ? mkPrice : UNIT;
    return addVariant(vid, 1).then(function () {
      try {
        if (window.CBCTrack) window.CBCTrack.addToCart({ source: source, items: [{ id: vid, quantity: 1, price: unit }], valueCents: unit,
          currency: mkPrice != null ? MK.currency : (cart.currency || "USD") });
      } catch (x) {}
    });
  }

  function enforceGift() {
    if (giftBusy || inFlight || Object.keys(pending).length) return;
    if (enforceProtect()) return;
    if (!GIFT_IDS.length) return;
    var gifts = giftLines();
    var n = gameBookCount();
    if (n >= GIFT_MIN) {
      var toAdd = [];
      expectedGifts().forEach(function (g) {
        var ls = (cart.items || []).filter(function (it) { return it.variant_id === g.id; });
        if (!ls.length) { toAdd.push({ id: g.id, quantity: g.qty, properties: { _offert: "1" } }); return; }
        if (ls[0].quantity !== g.qty) setQty(ls[0].key, g.qty);
        ls.slice(1).forEach(function (it) { setQty(it.key, 0); });
      });
      if (toAdd.length) {
        giftBusy = true;
        addItems(toAdd).then(function () { giftBusy = false; });
      }
    } else if (gifts.length) {
      gifts.forEach(function (it) { setQty(it.key, 0); });
    }
  }

  function showError(msg) {
    var e = $("[data-cbcd-err]"); if (!e) return;
    e.textContent = msg || ""; e.style.display = msg ? "" : "none";
  }

  function upsellVariantId() {
    var sel = $("[data-cbcd-upvar]"); if (sel) return parseInt(sel.value, 10);
    var tog = $("[data-cbcd-uptog]"); return tog ? parseInt(tog.getAttribute("data-variant"), 10) : 0;
  }
  function upsellInCart() {
    var pid = upsellEl && upsellEl.getAttribute("data-product");
    if (!pid) return null;
    return (cart.items || []).filter(function (it) { return String(it.product_id) === pid; })[0] || null;
  }
  function syncUpsell() {
    var tog = $("[data-cbcd-uptog]"); if (!tog) return;
    var line = upsellInCart();
    if (line) tog.setAttribute("data-on", ""); else tog.removeAttribute("data-on");
    var sel = $("[data-cbcd-upvar]"); if (sel && line) sel.value = line.variant_id;
  }

  itemsEl.addEventListener("click", function (e) {
    if (!e.target || !e.target.closest) return;
    var b = e.target.closest("button[data-act]"); if (!b) return;
    var act = b.getAttribute("data-act");
    if (act === "more") {
      var h = b.getAttribute("data-handle");
      if (!moreOpen[h]) {
        moreOpen[h] = true; render();
        var sel0 = itemsEl.querySelector('[data-morevar="' + h + '"]'); if (sel0) sel0.focus();
        return;
      }
      var sel = itemsEl.querySelector('[data-morevar="' + h + '"]');
      if (!sel || !sel.value) { if (sel) sel.focus(); return; }
      moreOpen[h] = false; shopperAdd(parseInt(sel.value, 10), "drawer-recipient");
      return;
    }
    var keys = (b.getAttribute("data-keys") || "").split("|").filter(Boolean);
    if (!keys.length) return;
    if (act === "del") { keys.forEach(function (k) { setQty(k, 0); }); return; }
    if (act === "inc") { var first = lineByKey(keys[0]); if (first) setQty(first.key, first.quantity + 1); return; }
    for (var i = keys.length - 1; i >= 0; i--) {
      var l = lineByKey(keys[i]);
      if (l && l.quantity > 0) { setQty(l.key, l.quantity - 1); return; }
    }
  });

  root.addEventListener("click", function (e) {
    if (!e.target || !e.target.closest) return;
    var tog = e.target.closest("[data-cbcd-uptog]");
    if (tog) {
      var line = upsellInCart();
      if (line) (cart.items || []).filter(function (it) { return it.variant_id === line.variant_id; }).forEach(function (it) { setQty(it.key, 0); });
      else shopperAdd(upsellVariantId(), "drawer-upsell");
      return;
    }
    if (e.target.closest("[data-cbcd-close]")) close();
  });

  root.addEventListener("change", function (e) {
    if (e.target.matches("[data-cbcd-protect-toggle]")) {
      setProtectOff(!e.target.checked);
      var row = $("[data-cbcd-protect]");
      if (row) { if (e.target.checked) row.setAttribute("data-on", ""); else row.removeAttribute("data-on"); }
      enforceProtect();
      return;
    }
    if (!e.target.matches("[data-cbcd-upvar]")) return;
    var line = upsellInCart(); if (!line) return;
    var next = parseInt(e.target.value, 10); if (next === line.variant_id) return;
    root.setAttribute("data-busy", "");
    var upd = {}; upd[line.key] = 0;
    post("/cart/update.js", { updates: upd })
      .then(function () { return post("/cart/add.js", { items: [{ id: next, quantity: line.quantity }] }); })
      .then(getCart).then(setCart)
      .catch(function (err) { showError(err.message); })
      .then(function () { root.removeAttribute("data-busy"); render(); });
  });

  function setInert(on) {
    [".page-wrapper", "#header-group", "footer"].forEach(function (sel) {
      var el = document.querySelector(sel); if (el && "inert" in el) el.inert = on;
    });
  }
  function open() {
    if (root.hasAttribute("data-open")) return;
    lastFocus = document.activeElement;
    root.hidden = false; scrim.hidden = false;
    requestAnimationFrame(function () { root.setAttribute("data-open", ""); scrim.setAttribute("data-open", ""); });
    document.documentElement.style.overflow = "hidden"; document.body.style.overflow = "hidden";
    setInert(true);
    var c = $("[data-cbcd-close]"); if (c) c.focus();
  }
  function close() {
    root.removeAttribute("data-open"); scrim.removeAttribute("data-open");
    document.documentElement.style.overflow = ""; document.body.style.overflow = "";
    setInert(false);
    window.setTimeout(function () { root.hidden = true; scrim.hidden = true; }, 280);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  scrim.addEventListener("click", close);
  document.addEventListener("keydown", function (e) { if (e.key === "Escape" && root.hasAttribute("data-open")) close(); });
  document.addEventListener("click", function (e) {
    if (!e.target || !e.target.closest) return;
    var t = e.target.closest('a[href$="/cart"], a[href*="/cart?"], [data-cbcd-open]');
    if (!t) return;
    e.preventDefault(); e.stopPropagation();
    refresh().then(open);
  }, true);

  function refresh() {
    return getCart().then(function (c) { setCart(c); render(); enforceGift(); }).catch(function () {});
  }
  window.addEventListener("pageshow", function (e) {
    if (e.persisted) { root.removeAttribute("data-busy"); refresh(); }
  });

  /* Horizon's own cart drawer must never show: it has its own Checkout button. Hide it now and
     again whenever the theme re-renders it. */
  function hideNativeDrawer() {
    ["cart-drawer-component", "#cart-drawer", ".cart-drawer"].forEach(function (sel) {
      var el = document.querySelector(sel);
      if (el && el.style.display !== "none") { el.style.display = "none"; el.setAttribute("aria-hidden", "true"); }
    });
  }
  hideNativeDrawer();
  if (window.MutationObserver) {
    new MutationObserver(hideNativeDrawer).observe(document.body, { childList: true, subtree: false });
  }

  window.CBCCart = {
    open: function () { return refresh().then(open); },
    close: close, refresh: refresh,
    add: function (items) { return post("/cart/add.js", { items: items }).then(refresh).then(open); },
    _state: function () { return { cart: cart, pending: pending, inFlight: inFlight, market: mq }; }
  };

  if (CART_PATH.test(window.location.pathname)) window.setTimeout(function () { refresh().then(open); }, 0);

  render();
  enforceGift();
})();
